@if (isLoading()) {
  <div class="loading-overlay">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
  